// Slovenské dvojče locale/cs/searchAnalytics.js.
export default {
  listName: 'Vyhľadávanie',
};
